import { IAddress } from '@commenda/types';
import { Country } from '@prisma/client';

export const addressesEqual = (a?: IAddress, b?: IAddress): boolean => {
  if (!a || !b) return false;

  return (
    a.addressLine1?.trim() === b.addressLine1?.trim() &&
    a.addressLine2?.trim() === b.addressLine2?.trim() &&
    a.city?.trim() === b.city?.trim() &&
    a.state?.trim() === b.state?.trim() &&
    a.postalCode?.trim() === b.postalCode?.trim() &&
    a.country === Country.US &&
    b.country === Country.US
  );
};
